<template>
  <el-tabs v-model="activeTab">
    <el-tab-pane label="圈子列表" name="circle">
      <ContentWrap>
        <el-form ref="queryFormRef" :inline="true" :model="query">
          <el-form-item label="关键词" prop="keyword"
            ><el-input v-model="query.keyword" clearable placeholder="名称/行业" @keyup.enter="search"
          /></el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="query.status" clearable class="!w-140px">
              <el-option label="上架" :value="1" /><el-option label="未上架" :value="0" /><el-option
                label="禁用"
                :value="2"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="上架审" prop="verifyStatus">
            <el-select v-model="query.verifyStatus" clearable class="!w-140px">
              <el-option label="待审" :value="0" />
              <el-option label="通过" :value="1" />
              <el-option label="驳回" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="search">搜索</el-button>
            <el-button @click="reset">重置</el-button>
            <el-button v-hasPermi="['bosscircle:circle:create']" type="primary" @click="openForm()"
              >新增商圈</el-button
            >
          </el-form-item>
        </el-form>
      </ContentWrap>
      <ContentWrap>
        <el-table v-loading="loading" :data="list">
          <el-table-column prop="id" label="编号" width="80" />
          <el-table-column label="图标" width="72">
            <template #default="s">
              <el-image
                v-if="s.row.circleIcon"
                :src="s.row.circleIcon"
                class="!h-40px !w-40px"
                fit="cover"
                :preview-src-list="[s.row.circleIcon]"
                preview-teleported
              />
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="商圈名称" min-width="160" show-overflow-tooltip>
            <template #default="s">
              <div class="font-500">{{ s.row.circleName || '-' }}</div>
              <div v-if="s.row.circleDesc" class="text-12px text-#909399 truncate">{{ s.row.circleDesc }}</div>
            </template>
          </el-table-column>
          <el-table-column label="圈主" min-width="160">
            <template #default="s">
              <template v-if="s.row.ownerUserId">
                <div>{{ s.row.ownerNickname || `用户${s.row.ownerUserId}` }}</div>
                <div class="text-12px text-#909399">
                  ID {{ s.row.ownerUserId }}
                  <span v-if="s.row.ownerMobile"> · {{ s.row.ownerMobile }}</span>
                </div>
              </template>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="industry" label="行业" width="100" show-overflow-tooltip />
          <el-table-column prop="tagLabels" label="标签" min-width="120" show-overflow-tooltip />
          <el-table-column prop="mission" label="核心宗旨" min-width="140" show-overflow-tooltip />
          <el-table-column prop="goalText" label="目标定位" min-width="140" show-overflow-tooltip />
          <el-table-column label="上架审" width="90">
            <template #default="s">
              <el-tag v-if="s.row.verifyStatus === 0" type="warning">待审</el-tag>
              <el-tag v-else-if="s.row.verifyStatus === 1" type="success">通过</el-tag>
              <el-tag v-else-if="s.row.verifyStatus === 2" type="danger">驳回</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="verifyRemark" label="驳回原因" min-width="120" show-overflow-tooltip />
          <el-table-column label="官方" width="70">
            <template #default="s"
              ><el-tag v-if="s.row.officialFlag" type="warning">官方</el-tag
              ><span v-else>-</span></template
            >
          </el-table-column>
          <el-table-column label="付费" width="90">
            <template #default="s">{{ s.row.isPaid ? `¥${s.row.price || 0}` : '免费' }}</template>
          </el-table-column>
          <el-table-column prop="memberCount" label="成员" width="70" />
          <el-table-column prop="feedCount" label="动态" width="70" />
          <el-table-column prop="sortOrder" label="排序" width="70" />
          <el-table-column label="状态" width="90">
            <template #default="s"
              ><el-tag :type="s.row.status === 1 ? 'success' : 'info'">{{
                s.row.status === 1 ? '上架' : s.row.status === 2 ? '禁用' : '未上架'
              }}</el-tag></template
            >
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170" />
          <el-table-column label="操作" width="220" fixed="right">
            <template #default="s">
              <el-button v-hasPermi="['bosscircle:circle:update']" link type="primary" @click="openForm(s.row.id)"
                >编辑</el-button
              >
              <el-button
                v-if="s.row.verifyStatus === 0"
                v-hasPermi="['bosscircle:circle:update']"
                link
                type="warning"
                @click="openCircleAudit(s.row)"
                >审核</el-button
              >
              <el-button
                v-hasPermi="['bosscircle:circle-member:query']"
                link
                type="success"
                @click="openMembers(s.row)"
                >成员</el-button
              >
              <el-button
                v-hasPermi="['bosscircle:circle:delete']"
                link
                type="danger"
                @click="removeCircle(s.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          v-model:page="query.pageNo"
          v-model:limit="query.pageSize"
          :total="total"
          @pagination="load"
        />
      </ContentWrap>
    </el-tab-pane>

    <el-tab-pane label="圈主审核" name="owner">
      <ContentWrap>
        <el-form :inline="true" :model="ownerQuery">
          <el-form-item label="状态">
            <el-select v-model="ownerQuery.status" clearable class="!w-160px">
              <el-option label="待支付" :value="0" />
              <el-option label="待审" :value="1" />
              <el-option label="通过" :value="2" />
              <el-option label="驳回" :value="3" />
              <el-option label="已撤销" :value="4" />
            </el-select>
          </el-form-item>
          <el-form-item label="会员">
            <el-input
              v-model="ownerQuery.keyword"
              clearable
              class="!w-220px"
              placeholder="昵称/姓名/手机/用户ID"
              @keyup.enter="loadOwners"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="loadOwners">搜索</el-button>
            <el-button @click="resetOwners">重置</el-button>
          </el-form-item>
        </el-form>
      </ContentWrap>
      <ContentWrap>
        <el-table v-loading="ownerLoading" :data="ownerList">
          <el-table-column prop="id" label="申请ID" width="90" />
          <el-table-column label="会员资料" min-width="220">
            <template #default="s">
              <div class="flex items-center gap-10px">
                <el-avatar :size="40" :src="s.row.avatar || undefined">
                  <Icon icon="ep:user-filled" />
                </el-avatar>
                <div class="min-w-0">
                  <div class="font-500 truncate">
                    {{ s.row.realName || s.row.nickname || `用户${s.row.userId}` }}
                  </div>
                  <div class="text-12px text-#909399 truncate">
                    昵称 {{ s.row.nickname || '-' }}
                    <span v-if="s.row.realName && s.row.nickname"> · 姓名 {{ s.row.realName }}</span>
                  </div>
                  <div class="text-12px text-#909399">
                    {{ s.row.mobile || '无手机号' }} · ID {{ s.row.userId }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="公司/职位" min-width="140" show-overflow-tooltip>
            <template #default="s">
              {{ [s.row.company, s.row.position].filter(Boolean).join(' · ') || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="officeAddress" label="场地地址" min-width="140" show-overflow-tooltip />
          <el-table-column prop="applyRemark" label="申请说明" min-width="120" show-overflow-tooltip />
          <el-table-column label="营业执照" width="88">
            <template #default="s">
              <el-image
                v-if="s.row.licenseUrl"
                :src="s.row.licenseUrl"
                class="!h-48px !w-48px"
                fit="cover"
                :preview-src-list="[s.row.licenseUrl]"
                preview-teleported
              />
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="场地实拍" min-width="160">
            <template #default="s">
              <div v-if="parseVenueImages(s.row.venueImagesJson).length" class="flex flex-wrap gap-4px">
                <el-image
                  v-for="(url, idx) in parseVenueImages(s.row.venueImagesJson)"
                  :key="idx"
                  :src="url"
                  class="!h-40px !w-40px"
                  fit="cover"
                  :preview-src-list="parseVenueImages(s.row.venueImagesJson)"
                  :initial-index="idx"
                  preview-teleported
                />
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="tierAmount" label="资格费" width="90" />
          <el-table-column prop="tradeOrderId" label="统一订单" width="100" />
          <el-table-column label="状态" width="90">
            <template #default="s">{{ ownerStatusText(s.row.status) }}</template>
          </el-table-column>
          <el-table-column prop="rejectReason" label="驳回原因" min-width="120" show-overflow-tooltip />
          <el-table-column prop="paidTime" label="支付时间" width="170" />
          <el-table-column label="操作" width="100" fixed="right">
            <template #default="s">
              <el-button
                v-if="s.row.status === 1"
                v-hasPermi="['bosscircle:circle:update']"
                link
                type="warning"
                @click="openOwnerAudit(s.row)"
                >审核</el-button
              >
              <el-button v-else link type="primary" @click="openOwnerAudit(s.row, true)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          v-model:page="ownerQuery.pageNo"
          v-model:limit="ownerQuery.pageSize"
          :total="ownerTotal"
          @pagination="loadOwners"
        />
      </ContentWrap>
    </el-tab-pane>
  </el-tabs>

  <!-- 编辑/新增：覆盖用户端提交全部字段 -->
  <Dialog v-model="formVisible" :title="form.id ? '编辑商圈' : '新增商圈'" width="720px">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="名称" prop="circleName"><el-input v-model="form.circleName" maxlength="64" /></el-form-item>
      <el-form-item label="图标"><UploadImg v-model="form.circleIcon" /></el-form-item>
      <el-form-item label="描述"
        ><el-input v-model="form.circleDesc" type="textarea" :rows="3" maxlength="1000" show-word-limit
      /></el-form-item>
      <el-form-item label="核心宗旨"
        ><el-input v-model="form.mission" type="textarea" :rows="2" maxlength="500" show-word-limit
      /></el-form-item>
      <el-form-item label="目标定位"
        ><el-input v-model="form.goalText" type="textarea" :rows="2" maxlength="500" show-word-limit
      /></el-form-item>
      <el-form-item label="行业"><el-input v-model="form.industry" maxlength="64" /></el-form-item>
      <el-form-item label="行业编码"><el-input v-model="form.industryCode" maxlength="64" /></el-form-item>
      <el-form-item label="展示标签"
        ><el-input v-model="form.tagLabels" placeholder="行业圈/协会等，逗号分隔" maxlength="255"
      /></el-form-item>
      <el-form-item label="圈主用户ID"
        ><el-input-number v-model="form.ownerUserId" :min="1" :controls="false" class="!w-200px" placeholder="可选"
      /></el-form-item>
      <el-form-item label="官方"><el-switch v-model="form.officialFlag" /></el-form-item>
      <el-form-item label="联合创办"
        ><el-input v-model="form.coOrganizers" placeholder="官方圈联合创办方文案"
      /></el-form-item>
      <el-form-item label="付费入圈"><el-switch v-model="form.isPaid" /></el-form-item>
      <el-form-item v-if="form.isPaid" label="入圈价"
        ><el-input-number v-model="form.price" :min="0" :precision="2"
      /></el-form-item>
      <el-form-item label="排序"><el-input-number v-model="form.sortOrder" :min="0" /></el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :value="1">上架</el-radio>
          <el-radio :value="0">未上架</el-radio>
          <el-radio :value="2">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      <el-button @click="formVisible = false">取消</el-button>
    </template>
  </Dialog>

  <!-- 圈子上架审核：上方资料，下方操作 -->
  <Dialog v-model="circleAuditVisible" title="圈子上架审核" width="720px">
    <el-descriptions :column="2" border class="mb-16px" label-width="96px">
      <el-descriptions-item label="商圈名称" :span="2">{{
        circleAudit.row?.circleName || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="图标" :span="2">
        <el-image
          v-if="circleAudit.row?.circleIcon"
          :src="circleAudit.row.circleIcon"
          class="!h-64px !w-64px"
          fit="cover"
          :preview-src-list="[circleAudit.row.circleIcon]"
          preview-teleported
        />
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="圈主" :span="2">
        <template v-if="circleAudit.row?.ownerUserId">
          {{ circleAudit.row.ownerNickname || `用户${circleAudit.row.ownerUserId}` }}（ID
          {{ circleAudit.row.ownerUserId }}）
          <span v-if="circleAudit.row.ownerMobile"> · {{ circleAudit.row.ownerMobile }}</span>
        </template>
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="行业">{{ circleAudit.row?.industry || '-' }}</el-descriptions-item>
      <el-descriptions-item label="行业编码">{{
        circleAudit.row?.industryCode || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="展示标签" :span="2">{{
        circleAudit.row?.tagLabels || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="描述" :span="2">{{
        circleAudit.row?.circleDesc || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="核心宗旨" :span="2">{{
        circleAudit.row?.mission || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="目标定位" :span="2">{{
        circleAudit.row?.goalText || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="入圈费用">{{
        circleAudit.row?.isPaid ? `¥${circleAudit.row.price || 0}` : '免费'
      }}</el-descriptions-item>
      <el-descriptions-item label="官方">{{
        circleAudit.row?.officialFlag ? '是' : '否'
      }}</el-descriptions-item>
      <el-descriptions-item label="联合创办" :span="2">{{
        circleAudit.row?.coOrganizers || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="创建时间" :span="2">{{
        circleAudit.row?.createTime || '-'
      }}</el-descriptions-item>
    </el-descriptions>
    <el-divider content-position="left">审核操作</el-divider>
    <el-form label-width="96px">
      <el-form-item label="审核结果">
        <el-radio-group v-model="circleAudit.pass">
          <el-radio :value="true">通过并上架</el-radio>
          <el-radio :value="false">驳回</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="!circleAudit.pass" label="驳回原因" required>
        <el-input
          v-model="circleAudit.rejectReason"
          type="textarea"
          :rows="3"
          maxlength="200"
          show-word-limit
          placeholder="请填写驳回原因，将反馈给圈主"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="circleAuditVisible = false">取消</el-button>
      <el-button type="primary" :loading="circleAudit.saving" @click="submitCircleAudit">提交审核</el-button>
    </template>
  </Dialog>

  <!-- 圈主资格审核：上方资料，下方操作 -->
  <Dialog v-model="ownerAuditVisible" :title="ownerAudit.readonly ? '圈主申请详情' : '圈主资格审核'" width="720px">
    <el-descriptions :column="2" border class="mb-16px" label-width="96px">
      <el-descriptions-item label="会员资料" :span="2">
        <div class="flex items-center gap-12px">
          <el-avatar :size="48" :src="ownerAudit.row?.avatar || undefined">
            <Icon icon="ep:user-filled" />
          </el-avatar>
          <div>
            <div>
              姓名 {{ ownerAudit.row?.realName || '-' }} · 昵称
              {{ ownerAudit.row?.nickname || `用户${ownerAudit.row?.userId}` }}
            </div>
            <div class="text-12px text-#909399">
              {{ ownerAudit.row?.mobile || '无手机号' }} · ID {{ ownerAudit.row?.userId }}
            </div>
          </div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="公司">{{ ownerAudit.row?.company || '-' }}</el-descriptions-item>
      <el-descriptions-item label="职位">{{ ownerAudit.row?.position || '-' }}</el-descriptions-item>
      <el-descriptions-item label="资格费">{{ ownerAudit.row?.tierAmount ?? '-' }}</el-descriptions-item>
      <el-descriptions-item label="场地地址" :span="2">{{
        ownerAudit.row?.officeAddress || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="申请说明" :span="2">{{
        ownerAudit.row?.applyRemark || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="营业执照" :span="2">
        <el-image
          v-if="ownerAudit.row?.licenseUrl"
          :src="ownerAudit.row.licenseUrl"
          class="!h-100px !w-160px"
          fit="contain"
          :preview-src-list="[ownerAudit.row.licenseUrl]"
          preview-teleported
        />
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="场地实拍" :span="2">
        <div v-if="ownerVenueImages.length" class="flex flex-wrap gap-8px">
          <el-image
            v-for="(url, idx) in ownerVenueImages"
            :key="idx"
            :src="url"
            class="!h-80px !w-80px"
            fit="cover"
            :preview-src-list="ownerVenueImages"
            :initial-index="idx"
            preview-teleported
          />
        </div>
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="统一订单">{{ ownerAudit.row?.tradeOrderId || '-' }}</el-descriptions-item>
      <el-descriptions-item label="支付时间">{{ ownerAudit.row?.paidTime || '-' }}</el-descriptions-item>
      <el-descriptions-item label="当前状态">{{ ownerStatusText(ownerAudit.row?.status) }}</el-descriptions-item>
      <el-descriptions-item label="驳回原因">{{ ownerAudit.row?.rejectReason || '-' }}</el-descriptions-item>
    </el-descriptions>
    <template v-if="!ownerAudit.readonly && ownerAudit.row?.status === 1">
      <el-divider content-position="left">审核操作</el-divider>
      <el-form label-width="96px">
        <el-form-item label="审核结果">
          <el-radio-group v-model="ownerAudit.pass">
            <el-radio :value="true">通过</el-radio>
            <el-radio :value="false">驳回（自动退款）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="!ownerAudit.pass" label="驳回原因" required>
          <el-input
            v-model="ownerAudit.rejectReason"
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
            placeholder="驳回将自动退款，请填写原因"
          />
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <el-button @click="ownerAuditVisible = false">{{ ownerAudit.readonly ? '关闭' : '取消' }}</el-button>
      <el-button
        v-if="!ownerAudit.readonly && ownerAudit.row?.status === 1"
        type="primary"
        :loading="ownerAudit.saving"
        @click="submitOwnerAudit"
        >提交审核</el-button
      >
    </template>
  </Dialog>

  <Dialog v-model="memberVisible" :title="`${currentCircle?.circleName || ''} - 成员管理`" width="720px">
    <el-table v-loading="memberLoading" :data="members">
      <el-table-column prop="id" label="成员记录" />
      <el-table-column prop="userId" label="用户编号" />
      <el-table-column prop="role" label="角色"
        ><template #default="s">{{ s.row.role === 1 ? '圈主' : '成员' }}</template></el-table-column
      >
      <el-table-column prop="createTime" label="加入时间" :formatter="dateFormatter" />
      <el-table-column label="操作">
        <template #default="s">
          <el-button
            v-hasPermi="['bosscircle:circle-member:delete']"
            link
            type="danger"
            @click="removeCircleMember(s.row.id)"
            >移除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="memberQuery.pageNo"
      v-model:limit="memberQuery.pageSize"
      :total="memberTotal"
      @pagination="loadMembers"
    />
    <template #footer>
      <div class="flex justify-end w-full">
        <el-button type="primary" @click="memberVisible = false">关闭</el-button>
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { dateFormatter } from '@/utils/formatTime'
import * as Api from '@/api/business/circle'
import * as OwnerApi from '@/api/business/circleOwner'

defineOptions({ name: 'BossCircleCircle' })
const message = useMessage()
const activeTab = ref('circle')
const loading = ref(false)
const saving = ref(false)
const list = ref<Api.CircleVO[]>([])
const total = ref(0)
const queryFormRef = ref()
const formRef = ref()
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  keyword: '',
  status: undefined as number | undefined,
  verifyStatus: undefined as number | undefined
})
const empty = () => ({
  id: undefined as number | undefined,
  circleName: '',
  circleIcon: '',
  circleDesc: '',
  mission: '',
  goalText: '',
  industry: '',
  industryCode: '',
  tagLabels: '',
  ownerUserId: undefined as number | undefined,
  officialFlag: false,
  coOrganizers: '',
  isPaid: false,
  price: 0,
  sortOrder: 0,
  status: 1
})
const form = reactive(empty())
const formVisible = ref(false)
const rules = { circleName: [{ required: true, message: '请输入商圈名称', trigger: 'blur' }] }

const load = async () => {
  loading.value = true
  try {
    const d = await Api.getCirclePage(query)
    list.value = d.list || []
    total.value = d.total || 0
  } finally {
    loading.value = false
  }
}
const search = () => {
  query.pageNo = 1
  load()
}
const reset = () => {
  queryFormRef.value?.resetFields()
  search()
}
const openForm = async (id?: number) => {
  Object.assign(form, empty())
  if (id) Object.assign(form, await Api.getCircle(id))
  formVisible.value = true
}
const save = async () => {
  if (!(await formRef.value?.validate().catch(() => false))) return
  saving.value = true
  try {
    form.id ? await Api.updateCircle(form) : await Api.createCircle(form)
    message.success('保存成功')
    formVisible.value = false
    load()
  } finally {
    saving.value = false
  }
}
const removeCircle = async (id: number) => {
  await message.delConfirm()
  await Api.deleteCircle(id)
  message.success('删除成功')
  load()
}

const circleAuditVisible = ref(false)
const circleAudit = reactive({
  row: undefined as Api.CircleVO | undefined,
  pass: true,
  rejectReason: '',
  saving: false
})
const openCircleAudit = async (row: Api.CircleVO) => {
  circleAudit.pass = true
  circleAudit.rejectReason = ''
  circleAudit.row = row
  circleAuditVisible.value = true
  if (row.id) {
    try {
      circleAudit.row = await Api.getCircle(row.id)
    } catch {
      // 列表行兜底
    }
  }
}
const submitCircleAudit = async () => {
  if (!circleAudit.row?.id) return
  if (!circleAudit.pass && !circleAudit.rejectReason.trim()) {
    message.warning('请填写驳回原因')
    return
  }
  circleAudit.saving = true
  try {
    await Api.verifyCircle({
      id: circleAudit.row.id,
      pass: circleAudit.pass,
      rejectReason: circleAudit.pass ? undefined : circleAudit.rejectReason.trim()
    })
    message.success(circleAudit.pass ? '已通过上架' : '已驳回')
    circleAuditVisible.value = false
    load()
  } finally {
    circleAudit.saving = false
  }
}

const memberVisible = ref(false)
const memberLoading = ref(false)
const members = ref<any[]>([])
const memberTotal = ref(0)
const currentCircle = ref<Api.CircleVO>()
const memberQuery = reactive({ pageNo: 1, pageSize: 10 })
const openMembers = (row: Api.CircleVO) => {
  currentCircle.value = row
  memberQuery.pageNo = 1
  memberVisible.value = true
  loadMembers()
}
const loadMembers = async () => {
  if (!currentCircle.value?.id) return
  memberLoading.value = true
  try {
    const d = await Api.getMemberPage({ ...memberQuery, circleId: currentCircle.value.id })
    members.value = d.list || []
    memberTotal.value = d.total || 0
  } finally {
    memberLoading.value = false
  }
}
const removeCircleMember = async (id: number) => {
  await message.delConfirm('确认移除该成员吗？')
  await Api.removeMember(currentCircle.value!.id!, id)
  message.success('移除成功')
  loadMembers()
  load()
}

const ownerLoading = ref(false)
const ownerList = ref<OwnerApi.CircleOwnerVO[]>([])
const ownerTotal = ref(0)
const ownerQuery = reactive({
  pageNo: 1,
  pageSize: 10,
  status: 1 as number | undefined,
  keyword: ''
})
const ownerStatusText = (s?: number) =>
  ({ 0: '待支付', 1: '待审', 2: '通过', 3: '驳回', 4: '已撤销' })[s ?? -1] || '-'
const parseVenueImages = (raw?: string) => {
  if (!raw) return [] as string[]
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((u) => typeof u === 'string' && u) : []
  } catch {
    return raw
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
  }
}
const loadOwners = async () => {
  ownerLoading.value = true
  try {
    const params: any = {
      pageNo: ownerQuery.pageNo,
      pageSize: ownerQuery.pageSize,
      status: ownerQuery.status
    }
    if (ownerQuery.keyword?.trim()) params.keyword = ownerQuery.keyword.trim()
    const d = await OwnerApi.getCircleOwnerPage(params)
    ownerList.value = d.list || []
    ownerTotal.value = d.total || 0
  } finally {
    ownerLoading.value = false
  }
}
const resetOwners = () => {
  ownerQuery.pageNo = 1
  ownerQuery.status = 1
  ownerQuery.keyword = ''
  loadOwners()
}

const ownerAuditVisible = ref(false)
const ownerAudit = reactive({
  row: undefined as OwnerApi.CircleOwnerVO | undefined,
  pass: true,
  rejectReason: '',
  saving: false,
  readonly: false
})
const ownerVenueImages = computed(() => parseVenueImages(ownerAudit.row?.venueImagesJson))
const openOwnerAudit = (row: OwnerApi.CircleOwnerVO, readonly = false) => {
  ownerAudit.row = row
  ownerAudit.pass = true
  ownerAudit.rejectReason = ''
  ownerAudit.readonly = readonly || row.status !== 1
  ownerAuditVisible.value = true
}
const submitOwnerAudit = async () => {
  if (!ownerAudit.row?.id) return
  if (!ownerAudit.pass && !ownerAudit.rejectReason.trim()) {
    message.warning('请填写驳回原因')
    return
  }
  ownerAudit.saving = true
  try {
    await OwnerApi.auditCircleOwner({
      id: ownerAudit.row.id,
      pass: ownerAudit.pass,
      rejectReason: ownerAudit.pass ? undefined : ownerAudit.rejectReason.trim()
    })
    message.success(ownerAudit.pass ? '已通过' : '已驳回并退款')
    ownerAuditVisible.value = false
    loadOwners()
  } finally {
    ownerAudit.saving = false
  }
}

watch(activeTab, (t) => {
  if (t === 'owner') loadOwners()
})
onMounted(load)
</script>
